/** Returns a snapshot of the current browser URL. */
export function getBrowserUrl(): URL {
  return new URL(window.location.href);
}

/** Reloads the current browser page. */
export function reload(): void {
  window.location.reload();
}
